import React, { memo } from 'react'

import { useBrandsAlphabet } from '@/screens/catalog-brands/hooks/useBrandsAlphabet'
import { BrandsAlphabet } from '@/screens/catalog-brands/ui/BrandsAlphabet/BrandsAlphabet'
import { BrandsAlphabetList } from '@/screens/catalog-brands/ui/BrandsAlphabetList/BrandsAlphabetList'
import { BrandsItem } from '@/screens/Home/page/types/types'

import { BrandsList } from '@/entities/catalog-brands'

import cl from './styles.module.scss'

interface DiscountCategoriesProps {
	categories: BrandsItem[]
}

export const BrandCategories = memo(function BrandCategories({ categories }: DiscountCategoriesProps): JSX.Element {
	const {
		groupedAll,
		ALL_LETTERS,
		topLetters,
		hasCyrillic,
		activeLetter,
		isRussianActive,
		onClickLetter,
		onClickRussian
	} = useBrandsAlphabet(categories)

	return (
		<div>
			<div className={cl.brands}>
				<h2 className={cl.brands__title}>Популярные бренды</h2>
				<BrandsList brands={categories} />

				<h2 className={cl.brands__title}>Все бренды</h2>

				{/* --- Верхняя навигация --- */}
				<BrandsAlphabet
					topLetters={topLetters}
					hasCyrillic={hasCyrillic}
					activeLetter={activeLetter}
					isRussianActive={isRussianActive}
					onClickLetter={onClickLetter}
					onClickRussian={onClickRussian}
				/>

				{/* --- Нижний список --- */}
				<BrandsAlphabetList allLetters={ALL_LETTERS} groupedAll={groupedAll} activeLetter={activeLetter} />
			</div>
		</div>
	)
})
